import { EventStorage } from "src/core/contract/EventStorage";
import { Event } from "src/core/model/Event";

/**
 * In-memory event storage with queue semantics.
 * Mirrors Android InMemoryEventStorage.
 */
export class InMemoryEventStorage implements EventStorage {
  private events: Event[] = [];

  saveEvent(event: Event): void {
    this.events.push(event);
  }

  getPendingEvents(): Event[] {
    return [...this.events];
  }

  removeEvent(event: Event): void {
    this.events = this.events.filter((e) => e.key !== event.key);
  }

  clear(): void {
    this.events = [];
  }
}
